export default __webpack_public_path__ + "static/media/single-sentence.9a3cb0d7.svg";